/* SLIDE UP */
const slideUp = (target, duration, callback) => {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = `${duration}ms`;
  // target.style.boxSizing = 'border-box';
  target.style.height = `${target.offsetHeight}px`;
  target && target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = "0";
  target.style.paddingTop = "0";
  target.style.paddingBottom = "0";
  target.style.marginTop = "0";
  target.style.marginBottom = "0";
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    callback && callback();
  }, duration);
};

/* SLIDE DOWN */
const slideDown = (target, duration, callback) => {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") {
    display = "block";
  }
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = "0";
  target.style.paddingTop = "0";
  target.style.paddingBottom = "0";
  target.style.marginTop = "0";
  target.style.marginBottom = "0";
  target && target.offsetHeight;
  // target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${height}px`;
  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    callback && callback();
  }, duration);
};

const debounce = func => {
  let timer;
  return function (event) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(func, 100, event);
  };
};

const hasClass = (element, cls) =>
  stringTrim(cls)
    .split(" ")
    .some(classStr => element.classList.contains(classStr));

const addClass = (element, cls) => {
  cls.split(" ").forEach(classStr => {
    element.classList.add(classStr);
  });
};

const removeClass = (element, cls) => {
  cls.split(" ").forEach(classStr => {
    element.classList.remove(classStr);
  });
};

const toggleClass = (element, cls) => {
  hasClass(element, cls) ? removeClass(element, cls) : addClass(element, cls);
};

const $$ = (element, str) =>
  (element &&
    (str || "").length > 0 &&
    Array.from(element.querySelectorAll(str))) ||
  null;

const $ = (element, str) =>
  (element && (str || "").length > 0 && $$(element, str)[0]) || null;
